// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_e2g","cls2":"ResearchInterestSearchResults-cls2_XJr ResearchInterestSearchResults-cls1_e2g"};